import { MessageType } from '../../utils/message';
const __DEBUG__ = false;
const __WATCH__ = false;
const __LOG__ = false;
function sendLogToBG(level, ...args) {
    if (__WATCH__ && __LOG__ && (__LOG__ === 'info' || level === 'warn')) {
        chrome.runtime.sendMessage({ type: MessageType.CS_LOG, data: { level, log: args } });
    }
}
export function logInfo(...args) {
    if (__DEBUG__) {
        console.info(...args);
        sendLogToBG('info', ...args);
    }
}
export function logWarn(...args) {
    if (__DEBUG__) {
        console.warn(...args);
        sendLogToBG('warn', ...args);
    }
}
export function logInfoCollapsed(title, ...args) {
    if (__DEBUG__) {
        console.groupCollapsed(title);
        console.log(...args);
        console.groupEnd();
    }
}
